import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/groves/$groveId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/today',
      search: { tab: 'groves', grove: params.groveId },
      replace: true,
    })
  },
})
